import i18n from '@/plugins/i18n';

export class BusinessActivity {

    public static Default(): BusinessActivity {
        return new BusinessActivity({ id: 0, name: i18n.t('common.ellipsis') });
    }

    public id: number = 0;
    public name?: string;
    public localizedName!: any;
    public parentId?: number;
    public selected: boolean = false;
    public levelTab: string = '';

    get value(): number | undefined {
        return this.id;
    }

    get text(): string | undefined {
        const allHtmlEntities = require('html-entities').AllHtmlEntities;

        let text = this.name;

        if (this.localizedName) {
            const resource = this.localizedName.find((l: any) => l.culture === i18n.locale)!.resource;
            text = resource[Object.keys(resource)[0]];
        }

        return text ? `${new allHtmlEntities().decode(this.levelTab)}${i18n.t(text).toString()}` : undefined;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { localizedName: json.localizedName ? JSON.parse(json.localizedName) : null });

        if (this.localizedName) {
            this.localizedName.forEach((name: any) => {
                i18n.mergeLocaleMessage(name.culture, name.resource);
            });
        }
    }

    public clone(): BusinessActivity {
        const activity = new BusinessActivity();

        activity.id = this.id;
        activity.name = this.name;
        activity.localizedName = this.localizedName;
        activity.parentId = this.parentId;
        activity.selected = this.selected;
        activity.levelTab = this.levelTab;

        return activity;
    }

    public getDefaultCategoryId(activities: BusinessActivity[]): number | undefined {
        const topActivity = this.getTopActivity(activities);
        if (!topActivity) {
            return undefined;
        }

        switch (topActivity.id) {
            case 1:
                return 1;
            case 2:
                return 10;
            case 3:
                return 8;
            case 4:
                return 5;
            case 5:
                return 4;
            case 6:
                return 3;
            case 7:
                return 7;
            case 8:
                return 11;
            case 10:
                return 13;
            case 12:
                return 6;
            default:
                return undefined;
        }
    }

    public getTopActivity(activities: BusinessActivity[]): BusinessActivity | undefined {
        if (!this.parentId) {
            return this;
        }

        if (!activities) {
            return undefined;
        }

        const parent = activities.find((a) => a.id === this.parentId);
        if (!parent) {
            return undefined;
        }

        return parent.getTopActivity(activities);
    }
}
